import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Paper
} from "@mui/material";

const formatCurrency = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? `$${number.toFixed(2)}` : "$0.00";
};

const SummaryCard = ({ label, value }) => (
  <Paper variant="outlined" sx={{ p: 1.25 }}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Typography variant="subtitle1">{value}</Typography>
  </Paper>
);

const CreatePOFormModal = ({ open, onClose, selectedRows, batchId, sessionId, summary, onCreated }) => {
  const [supplierName, setSupplierName] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = async () => {
    if (!supplierName || selectedRows.length === 0) {
      alert("Supplier name and at least one accepted PR must be available.");
      return;
    }

    try {
      const res = await fetch("/api/purchase_orders/create", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          supplier_name: supplierName,
          notes,
          ...(batchId ? { batch_id: batchId } : {}),
          ...(!batchId && sessionId ? { session_id: sessionId } : {}),
          ...(!batchId && !sessionId ? { purchase_request_ids: selectedRows.map((r) => r.id) } : {}),
        }),
      });

      const result = await res.json();
      if (res.ok) {
        console.log("✅ PO created:", result);
        if (onCreated) onCreated(result.purchase_order_id);
        onClose();
      } else {
        alert("Error creating PO: " + (result.error || "Unknown error"));
      }
    } catch (err) {
      console.error("❌ Failed to create PO:", err);
      alert("Failed to create PO");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create Purchase Order</DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Supplier Name"
          fullWidth
          margin="normal"
          value={supplierName}
          onChange={(e) => setSupplierName(e.target.value)}
          required
        />
        <TextField
          label="Notes"
          fullWidth
          margin="normal"
          multiline
          rows={3}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />

        <Box sx={{ mt: 2, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 1.25 }}>
          <SummaryCard label="Context" value={batchId ? `Batch ${batchId}` : sessionId ? `Legacy Session ${sessionId}` : "Manual"} />
          <SummaryCard label="Selected Rows" value={summary?.selectedCount || selectedRows.length} />
          <SummaryCard label="Offer Total" value={formatCurrency(summary?.offerTotal)} />
          <SummaryCard label="Predicted Total" value={formatCurrency(summary?.predictedTotal)} />
          <SummaryCard label="Projected Profit" value={formatCurrency(summary?.projectedProfit)} />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Create PO
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePOFormModal;
